/**
 * Métodos para postMessage
 * @type {Object}
 */
MdHub.postMessage = {
  // IE 8 - 9 enviam mensagens postMessage como string
  lastMessage: null,
  sendAsString: false,

  /**
   * Checa se o browser atual somente envia postMessages com string
   */
  checkSendAsString: function checkSendAsString() {
    if (navigator.appVersion.indexOf('MSIE 8') !== -1 || navigator.appVersion.indexOf('MSIE 9') !== -1) {
      this.sendAsString = true;
    }
  },

  /**
   * Callback executando quando o evento postMessage:message é disparado
   * @param  {Object} event Dados do evento
   */
  receive: function receive(event) {
    var data;
    var hash;
    var message = event.data; // Recupera as informações da mensagem.
    var promise;
    var self = this;

    if (this.sendAsString) {
      message = JSON.parse(event.data);
    }

    if (!message || (message.type !== 'command' && message.type !== 'event')) {
      return;
    }

    // Dispara um evento contendo a mensagem
    if (MdHub.module.options.mode === 'catchAll') {
      MdHub.event.call('core:catchAll', message);
    }

    // Caso o destinatário da mensagem seja a instância atual.
    if (message.to === 'broadcast' || message.to === MdHub.module.name) {
      if (message.type === 'command') {
        // Se for uma mensagem segura, recupera os dados a partir do local Storage
        if (message.secure && MdHub.hasStorage()) {
          hash = message.data;
          data = sessionStorage.getItem(hash);

          // O sessionStorage pode ser implementado de forma assíncrona pelo navegador
          // Aguarda o sessionStorage ter o dado
          if (data === undefined || data === null || data === 'undefined') {
            setTimeout(function recallReceive() {
              self.receive(event);
            }, 100);
            return;
          }

          if (data !== undefined && data !== 'undefined') {
            message.data = JSON.parse(data);
          } else {
            message.data = null;
          }

          sessionStorage.removeItem(hash);
        }

        // É a resposta de um comando enviado
        if (message.callback) {
          promise = MdHub.command.callbacks[message.id];

          // Se não tiver uma promessa, pode ser que ela já tenha sido resolvida
          if (promise) {
            // Pode acontecer da resposta chegar primeiro que a definição do callback
            // IE8 ;-)
            if (typeof promise[message.callback] !== 'function') {
              setTimeout(function interval() {
                if (typeof promise[message.callback] === 'function') {
                  promise[message.callback].call(this, message.data, message);
                }

                delete MdHub.command.callbacks[message.id];
              }, 1);
            } else {
              promise[message.callback].call(this, message.data, message);

              delete MdHub.command.callbacks[message.id];
            }
          }
        } else {
          // Rejeita um comando destinado a um módulo não existente
          // @TODO: Mensagem padrão de erro
          if (!MdHub.command.list[message.name]) {
            MdHub.command.reject(message);

            return;
          }

          // É o pedido de um comando
          MdHub.command.list[message.name].call(this, message.data, function success(result) {
            MdHub.command.resolve(message, result);
          }, function error(result) {
            MdHub.command.reject(message, result);
          });
        }
      } else if (message.type === 'event') {
        MdHub.event.call(message.name, message.data, message);
      }
    } else if (message.from !== MdHub.module.name && MdHub.mode === 'server') {
      MdHub.postMessage.send(message);

      if (message.type === 'event') {
        MdHub.event.call(message.name, message.data, message);
      }
    }
  },

  /**
   * Envia um postMessage
   * @param  {Object} message Diretrizes da mensagem
   */
  send: function send(message) {
    var i;
    var messageData = message;
    var target = messageData.to;
    var targetWindow = {};

    // Em modo Client envia o postMessage para o MdHub Server
    if (MdHub.mode === 'client') {
      messageData.from = MdHub.module.name;

      if (!messageData.id) {
        MdHub.command.commandId += 1;
        messageData.id = MdHub.command.commandId;
      }

      if (messageData.data && messageData.data.callbacks) {
        delete messageData.data.callbacks;
      }

      // Armazena as configurações da última mensagem enviada pelo módulo
      this.lastMessage = messageData;

      // Se possuir um callback para mensagens enviadas, dispara.
      if (MdHub.module.callbacks && Object.prototype.hasOwnProperty.call(MdHub.module.callbacks, 'beforeMessageSend') && MdHub.module.callbacks.beforeMessageSend) {
        MdHub.module.callbacks.beforeMessageSend.call(this, messageData);
      }

      // Não existe servidor, a mensagem será descartada
      if (window.parent.window === window) return;

      if (this.sendAsString) {
        messageData = JSON.stringify(messageData);
      }

      // Evita que ocorra um crash na aplicação caso a messageData seja um objeto
      if (typeof messageData === 'object' && messageData !== null) {
        messageData = JSON.parse(JSON.stringify(messageData));
      }

      window.parent.window.postMessage(messageData, '*');

      return;
    }

    // Em modo server, caso a mensagem tenha um target, envia diretamente para ele
    if (target) {
      if (this.sendAsString) {
        messageData = JSON.stringify(messageData);
      }

      // se estiver em mode server e o target for para o hub, dispara para todos os modulos
      if (target === 'hub') {
        window.postMessage(messageData, '*');
        return;
      }

      // Envia para os módulos com o modo catchAll habilitado
      for (i in MdHub.module.listCatchAll) {
        if (Object.prototype.hasOwnProperty.call(MdHub.module.listCatchAll, i)) {
          targetWindow = MdHub.module.list[i].window.contentWindow;

          if (targetWindow) {
            targetWindow.postMessage(messageData, '*');
          }
        }
      }

      // Se não existir ainda o target
      if (!MdHub.module.list[target]) {
        MdHub.command.reject(messageData);
        return;
      }

      targetWindow = MdHub.module.list[target].window.contentWindow;

      if (targetWindow) {
        targetWindow.postMessage(messageData, '*');
      }

      return;
    }

    messageData.to = 'broadcast';

    if (this.sendAsString) {
      messageData = JSON.stringify(messageData);
    }

    // Caso não possua um target, faz um boadcast para todos os módulos carregados.
    for (i in MdHub.module.list) {
      if (Object.prototype.hasOwnProperty.call(MdHub.module.list, i)) {
        targetWindow = MdHub.module.list[i].window.contentWindow;

        if (targetWindow) {
          targetWindow.postMessage(messageData, '*');
        }
      }
    }
  }
};
